<template>
  <span class="printer-document-content-block__inline-value">
    {{ block.value }}
  </span>
</template>

<script>
import { PrinterDocumentContentBlock } from '@/models/client/PrinterDocumentContentBlock.model';

export default {
  name: 'PrinterDocumentContentInlineValue',
  props: {
    block: [PrinterDocumentContentBlock, Object],
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
